<script setup lang="ts">
export interface Props {
  icon?: string;
}
const props = withDefaults(defineProps<Props>(), {
  icon: 'mdi-alert-circle-outline',
});
</script>

<template>
  <div
    :class="$style.reportGenerateDialogAlert"
    data-testid="reportGenerateDialogAlert"
  >
    <div :class="$style.iconItem">
      <v-icon :icon="props.icon"></v-icon>
    </div>
    <div :class="$style.textItem">
      <slot>Warning</slot>
    </div>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.reportGenerateDialogAlert {
  display: flex;
}

  .iconItem {
    color: colors.$color-yellow-500;
    font-size: 14px;
    padding-right: 8px;
    margin-top: -1px;
  }

  .textItem {
    color: colors.$color-text-tertiary;
    font-size: 16px;
    line-height: 22px;
  }
</style>
